import { env, getConfigValue, region } from '../environment';

interface GoogleTagManagerConfig {
  containerId?: string;
}

export function initGoogleTagManager() {
  const googleTagManagerConfig = getConfigValue({
    key: 'googleTagManager',
    region,
  } as any) as GoogleTagManagerConfig;
  const { containerId } = googleTagManagerConfig || {};

  if (!containerId) {
    return;
  }

  const scriptId = `rbi-bk-US-${env()}-google-tag-manager`;

  (function (w: Window, d: Document, l: string, i: string) {
    const existing = d.querySelectorAll(`script#${scriptId}`);

    if (existing.length > 0) {
      return;
    }

    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const f = d.getElementsByTagName('script')[0];
    const j = d.createElement('script');
    const dl = l !== 'dataLayer' ? '&l=' + l : '';

    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    j.id = scriptId;

    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      d.body.appendChild(j);
    }
  })(window, document, 'dataLayer', containerId);
}
